import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faDiscord,
  faPatreon,
  faTwitter
} from '@fortawesome/free-brands-svg-icons';

const Wrapper = styled.div`
  min-width: 16em;
  background: black;
  color: white;
  font-size: .65em;
  display: flex;

  & a {
    color: white;
  }
`

const SidebarContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: -webkit-sticky;
  position: sticky;
  top: 62px;

  & a:hover {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    align-items: center;
  }

  @media (max-width: 992px) {
    width: 16em;
  }
`

const SidebarItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: .4rem 1rem;
  border-bottom: 1px solid #333;
  text-decoration: none;
  text-transform: uppercase;

  &:hover {
    background: #228fd8;
    color: white;
  }

  @media (max-width: 992px) {
    width: 12em;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 2rem);
    text-align: center;
    justify-content: center;
    border-bottom: none;
  }
`

const SidebarItemLabel = styled.div``

const SidebarImages = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  min-height: 5rem;
`

const SocialIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  border-bottom: 1px solid #333;
  padding: .2rem 3rem .2rem 1rem;
  font-size: 1.5rem;
  text-decoration: none;
  text-transform: uppercase;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: .2rem;
    border-bottom: none;

    & a {
      padding: 0 .2em;
    }
  }
`

const LOLLink = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1em;
  
  & img {
    width: 6em;
  }

  & a:hover {
    background: none;
    opacity: 0.7;
  }
`

const GridContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 1em;

  @media (max-width: 768px) {
    margin-top: 0;
  }
`

const GridLogo = styled.img`
  width: 12em;
`

const SocialIcons = () => {
  return (
    <SocialIconsContainer className="sidebarSocialIcons">
      <a href="https://twitter.com/TimSevenhuysen" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faTwitter} />
      </a>
      <a href="https://discord.gg/KY6XHaF" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faDiscord} style={{ fontSize: "1.7rem" }} />
      </a>
      <a href="https://patreon.com/oracleselixir" target="_blank" rel="noopener noreferrer">
        <FontAwesomeIcon icon={faPatreon} />
      </a>
    </SocialIconsContainer>
  )
}

const SidebarItem = (props) => {
  return (
    <NavLink
      to={props.to}
      end
      className={({ isActive, isPending }) =>
        isPending ? 'navPending' : isActive ? 'navActive' : props.forceActive ? 'navActive' : ''
      }
    >
      <SidebarItemContainer>
        <SidebarItemLabel>
          {props.label}
        </SidebarItemLabel>
      </SidebarItemContainer>
    </NavLink>
  )
}

const LeftSidebar = ({ AppStore }) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  const location = useLocation();
  const currentRoute = location.pathname.substring(1, location.pathname.indexOf('/', 1));

  return (
    <Wrapper className='leftSidebar'>
      <SidebarContainer>
        <SocialIcons />
        <SidebarItem label='About' to='/about' />
        <SidebarItem label='Contact' to='/contact' />
        <SidebarItem label='RAR Explanation' to='/rar' />
        <GridContainer>
          <Link to='/about'><GridLogo src='/grid_badge.png' /></Link>
        </GridContainer>
        <LOLLink>
          <a
            href='https://oracleselixir.com'
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src='/LoL_Logo_Flat_GOLD.png' alt="Oracle's Elixir for League of Legends" />
          </a>
        </LOLLink>
      </SidebarContainer>
    </Wrapper>
  )
}

export default inject("AppStore")(observer(LeftSidebar));
